import React from "react";

const ASSET_BASE = process.env.PUBLIC_URL || "";

const PROJECTS = [
  {
    logo: `${ASSET_BASE}/embryomedicine.png`,
    nameKey: "works_project1_name",
    descKey: "works_project1_desc",
    ctaKey: "works_project1_cta",
    url: "https://apps.apple.com/us/app/%CE%B4%CF%81-%CE%B1%CE%B8-%CE%BC%CE%BF%CF%85%CF%83%CE%B9%CF%8E%CE%BB%CE%B7%CF%82/id6769809494",
    tags: {
      el: ["iOS", "Υγεία", "Δωρεάν", "Χωρίς Διαφημίσεις"],
      en: ["iOS", "Health", "Free", "No Ads"],
    },
  },
  {
    logo: `${ASSET_BASE}/embryomedicine.png`,
    nameKey: "works_project2_name",
    descKey: "works_project2_desc",
    ctaKey: "works_project2_cta",
    url: "https://play.google.com/store/apps/details?id=com.sotkou.embryomedicine.android",
    tags: {
      el: ["Android", "Υγεία", "Δωρεάν", "Χωρίς Διαφημίσεις"],
      en: ["Android", "Health", "Free", "No Ads"],
    },
  },
  {
    logo: `${ASSET_BASE}/airclub_karditsa.jpg`,
    nameKey: "works_project3_name",
    descKey: "works_project3_desc",
    ctaKey: "works_project3_cta",
    url: "https://www.aeroclub-karditsa.gr",
    tags: {
      el: ["Web App", "Διαχείριση", "Αερολέσχη", "Live"],
      en: ["Web App", "Management", "Aeroclub", "Live"],
    },
  },
];

export default function Works({ t, lang = "el" }) {
  const activeLang = lang || "el";

  return (
    <section
      id="works"
      style={{
        background: "var(--bg-secondary)",
        padding: "6rem 8vw",
      }}
    >
      {/* Heading */}
      <div style={{ textAlign: "center", marginBottom: "3rem" }}>
        <p
          style={{
            color: "var(--accent-purple)",
            fontWeight: 600,
            fontSize: "0.85rem",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            marginBottom: "0.75rem",
          }}
        >
          {t.works_label}
        </p>
        <h2
          style={{
            fontSize: "2.2rem",
            fontWeight: 800,
            color: "var(--text-primary)",
            margin: 0,
            letterSpacing: "-0.02em",
          }}
        >
          {t.works_title}
        </h2>
        <p
          style={{
            color: "var(--text-secondary)",
            marginTop: "1rem",
            fontSize: "1.05rem",
            maxWidth: 560,
            margin: "1rem auto 0",
          }}
        >
          {t.works_subtitle}
        </p>
      </div>

      {/* Project cards */}
      <div
        style={{
          maxWidth: 1080,
          margin: "0 auto",
          display: "grid",
          gap: "1.25rem",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
        }}
      >
        {PROJECTS.map((project, index) => {
          const tags = project.tags[activeLang] || project.tags.el;

          return (
            <div
              key={project.nameKey}
              style={{
                background: "var(--bg-card)",
                backdropFilter: "blur(16px)",
                WebkitBackdropFilter: "blur(16px)",
                border: "1px solid rgba(139,92,246,0.4)",
                borderRadius: "20px",
                boxShadow: "0 8px 48px rgba(139,92,246,0.18)",
                padding: "2rem",
                display: "flex",
                gap: "1.5rem",
                alignItems: "flex-start",
                flexWrap: "wrap",
              }}
            >
              {/* Icon */}
              <div
                style={{
                  width: 72,
                  height: 72,
                  borderRadius: "18px",
                  background: "#ffffff",
                  border: "1px solid rgba(139,92,246,0.35)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <img
                  src={project.logo}
                  alt={t[project.nameKey]}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    if (e.currentTarget.nextSibling) {
                      e.currentTarget.nextSibling.style.display = "flex";
                    }
                  }}
                />
                <span
                  style={{
                    display: "none",
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--text-primary)",
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    textAlign: "center",
                    padding: "0.25rem",
                  }}
                >
                  {t.works_badge}
                </span>
              </div>

              {/* Content */}
              <div style={{ flex: 1, minWidth: 220 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexWrap: "wrap", marginBottom: "0.5rem" }}>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      color: "var(--text-primary)",
                      margin: 0,
                    }}
                  >
                    {t[project.nameKey]}
                  </h3>
                  <span
                    style={{
                      background: "rgba(16,217,168,0.15)",
                      color: "#10d9a8",
                      border: "1px solid rgba(16,217,168,0.35)",
                      borderRadius: "20px",
                      fontSize: "0.72rem",
                      fontWeight: 600,
                      padding: "0.2rem 0.7rem",
                      letterSpacing: "0.04em",
                    }}
                  >
                    {t.works_badge}
                  </span>
                </div>

                <p
                  style={{
                    color: "var(--text-secondary)",
                    fontSize: "0.95rem",
                    lineHeight: 1.65,
                    margin: "0 0 1.25rem",
                  }}
                >
                  {t[project.descKey]}
                </p>

                {/* Tags */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", marginBottom: "1.25rem" }}>
                  {tags.map((tag) => (
                    <span
                      key={`${project.nameKey}-${tag}`}
                      style={{
                        background: "var(--bg-card-hover)",
                        border: "1px solid var(--border-hover)",
                        borderRadius: "8px",
                        fontSize: "0.78rem",
                        fontWeight: 500,
                        color: "var(--text-secondary)",
                        padding: "0.25rem 0.65rem",
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    background:
                      index === 0
                        ? "linear-gradient(135deg, #8b5cf6, #4f8ef7)"
                        : index === 1
                          ? "linear-gradient(135deg, #ec4899, #f59e0b)"
                          : "linear-gradient(135deg, #0ea5e9, #22c55e)",
                    color: "#fff",
                    padding: "0.7rem 1.5rem",
                    borderRadius: "10px",
                    fontWeight: 600,
                    fontSize: "0.92rem",
                    textDecoration: "none",
                    transition: "opacity 0.2s, transform 0.2s",
                    boxShadow: "0 4px 20px rgba(139,92,246,0.35)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = "0.88";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = "1";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3 20.5v-17c0-.83 1-.99 1.42-.42l14 8.5c.36.22.36.76 0 .98l-14 8.5C3.99 21.49 3 21.33 3 20.5z"/>
                  </svg>
                  {t[project.ctaKey]}
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
